import { PolicyRepository } from '../../domain/repositories/PolicyRepository';

export class FindContractDocument {
    constructor(private repository: PolicyRepository) {}

    async execute(policyIdentifier: string): Promise<Blob> {
        return this.repository.findDocumentPolicyIdentifier(policyIdentifier);
    }
}
